import { ApolloClient } from '@apollo/client/core';
import { SC_CARE_SESSIONS_QUERY } from '@/graphql/backup_care/queries';
import { CareType } from '@/types/care_type';

export function extractActiveScCareSessions(data: {
  corp?: { backupCare?: { bhReservationRequests?: Array<{ scCareSessions?: any[] }> } };
}): any[] {
  const bhReservationRequests = data.corp?.backupCare?.bhReservationRequests || [];
  const scCareSessions = bhReservationRequests.flatMap((reservation) => reservation.scCareSessions || []);
  const currentDateISO = new Date().toISOString();

  return scCareSessions.filter((session) => session.start >= currentDateISO);
}

export function extractScCareSessions(data: {
  corp?: { backupCare?: { bhReservationRequests?: Array<{ scCareSessions?: any[] }> } };
}): any[] {
  const bhReservationRequests = data.corp?.backupCare?.bhReservationRequests || [];

  return bhReservationRequests.flatMap((reservation) => reservation.scCareSessions || []);
}

export async function fetchActiveScCareSessions(apolloClient: ApolloClient<unknown>): Promise<any[]> {
  const { data } = await apolloClient.query({
    query: SC_CARE_SESSIONS_QUERY,
    fetchPolicy: 'network-only',
  });

  return extractActiveScCareSessions(data);
}

export function inferCareTypeFromSessions(activeSessions: any[]): CareType {
  const babysitterCareType = activeSessions.some((session) => [CareType.BABYSITTER].includes(session?.careType));
  const companionCareType = activeSessions.some((session) => [CareType.COMPANION_CARE].includes(session?.careType));

  return !babysitterCareType && companionCareType ? CareType.COMPANION_CARE : CareType.BABYSITTER;
}
